/* global Sys, Core */
Sys.ns("Core.Slots");

/**
 * The Server Manager module for slots.
 *
 * @class Core.Slots.ServerManager
 * @extends Core.Module
 */
Core.Slots.ServerManager = {

    constructor: function() {
        Core.Slots.ServerManager.superclass.constructor.apply(this, arguments);
    },

    /**
     * @protected
     * @inheritdoc
     */
    getStateChanges: function() {
        return {
            spinning: {
                queue: [
                    function(env) {
                        env.stateHandler.pushState(env.states.processServerResponse);
                    }
                ]
            },
            processServerResponse: {
                state: {
                    name: "ProcessServerResponse",
                    execute: function(env) {
                        // stub
                    },
                    waitEvents: {}
                }
            }

        };
    },

    /**
     * @protected
     * @inheritdoc
     */
    getDefaultMVCClasses: function() {
        return {
            model: Core.Slots.ServerManagerModel,
            view: Core.View,
            controller: Core.Slots.ServerManagerController
        };
    }
};

Core.Slots.ServerManager = Sys.extend(Core.Module, Core.Slots.ServerManager, "Core.Slots.ServerManager");
